import { useMemoizedFn } from 'ahooks'

import { pick } from '@eastcoal/common/utils/object'

import {
  PaperMarginType,
  PaperMarginTypeValueMap
} from '../../enums/PaperMarginType'
import { useContractDesignerEditorStore } from '../../Store/hooks/useStore'
import { PaperSpec } from '../../Store/store/interface'
import { getEditorStyleSheet } from '../../theme/styleManager'

const createPageStyleSheet = ({
  paperSpec,
  paperMarginType
}: {
  paperSpec: PaperSpec
  paperMarginType: PaperMarginType
}) => {
  return `
@page {
    size: ${paperSpec.width} ${paperSpec.height};
    margin: ${PaperMarginTypeValueMap[paperMarginType]};
}`
}

export const useEditorStyleSheetGetter = () => {
  const { paperSpec, paperMarginType } = useContractDesignerEditorStore(state =>
    pick(state, ['paperSpec', 'paperMarginType'])
  )

  return useMemoizedFn(() => {
    const pageStyleSheet = createPageStyleSheet({ paperSpec, paperMarginType })
    const editorStyleSheet = getEditorStyleSheet()
    return pageStyleSheet + '\n' + editorStyleSheet
  })
}
